/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateEnumerationEvaluationOptionDto } from './CreateEnumerationEvaluationOptionDto';
import {
    CreateEnumerationEvaluationOptionDtoFromJSON,
    CreateEnumerationEvaluationOptionDtoFromJSONTyped,
    CreateEnumerationEvaluationOptionDtoToJSON,
} from './CreateEnumerationEvaluationOptionDto';
import type { CreateEnumerationEvaluationParameterDtoTrackItFilter } from './CreateEnumerationEvaluationParameterDtoTrackItFilter';
import {
    CreateEnumerationEvaluationParameterDtoTrackItFilterFromJSON,
    CreateEnumerationEvaluationParameterDtoTrackItFilterFromJSONTyped,
    CreateEnumerationEvaluationParameterDtoTrackItFilterToJSON,
} from './CreateEnumerationEvaluationParameterDtoTrackItFilter';

/**
 * 
 * @export
 * @interface CreateEnumerationEvaluationParameterDto
 */
export interface CreateEnumerationEvaluationParameterDto {
    /**
     * 
     * @type {string}
     * @memberof CreateEnumerationEvaluationParameterDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEnumerationEvaluationParameterDto
     */
    dataTypeId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateEnumerationEvaluationParameterDto
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateEnumerationEvaluationParameterDto
     */
    allowRepetition?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateEnumerationEvaluationParameterDto
     */
    instruction?: string | null;
    /**
     * 
     * @type {Array<CreateEnumerationEvaluationOptionDto>}
     * @memberof CreateEnumerationEvaluationParameterDto
     */
    options?: Array<CreateEnumerationEvaluationOptionDto> | null;
    /**
     * 
     * @type {CreateEnumerationEvaluationParameterDtoTrackItFilter}
     * @memberof CreateEnumerationEvaluationParameterDto
     */
    trackItFilter?: CreateEnumerationEvaluationParameterDtoTrackItFilter | null;
    /**
     * 
     * @type {string}
     * @memberof CreateEnumerationEvaluationParameterDto
     */
    $type?: CreateEnumerationEvaluationParameterDtoTypeEnum;
}


/**
 * @export
 */
export const CreateEnumerationEvaluationParameterDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoEvaluationParametersCreateEnumerationEvaluationParameterDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.EvaluationParameters.CreateEnumerationEvaluationParameterDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateEnumerationEvaluationParameterDtoTypeEnum = typeof CreateEnumerationEvaluationParameterDtoTypeEnum[keyof typeof CreateEnumerationEvaluationParameterDtoTypeEnum];



/**
 * Check if a given object implements the CreateEnumerationEvaluationParameterDto interface.
 */
export function instanceOfCreateEnumerationEvaluationParameterDto(value?: unknown): value is CreateEnumerationEvaluationParameterDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateEnumerationEvaluationParameterDtoTypeEnum)[0];
}

export function CreateEnumerationEvaluationParameterDtoFromJSON(json: any): CreateEnumerationEvaluationParameterDto {
    return CreateEnumerationEvaluationParameterDtoFromJSONTyped(json, false);
}

export function CreateEnumerationEvaluationParameterDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateEnumerationEvaluationParameterDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'dataTypeId': json['dataTypeId'] == null ? undefined : json['dataTypeId'],
        'isEnabled': json['isEnabled'] == null ? undefined : json['isEnabled'],
        'allowRepetition': json['allowRepetition'] == null ? undefined : json['allowRepetition'],
        'instruction': json['instruction'] == null ? undefined : json['instruction'],
        'options': json['options'] == null ? undefined : ((json['options'] as Array<any>).map(CreateEnumerationEvaluationOptionDtoFromJSON)),
        'trackItFilter': json['trackItFilter'] == null ? undefined : CreateEnumerationEvaluationParameterDtoTrackItFilterFromJSON(json['trackItFilter']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function CreateEnumerationEvaluationParameterDtoToJSON(value?: CreateEnumerationEvaluationParameterDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'dataTypeId': value['dataTypeId'],
        'isEnabled': value['isEnabled'],
        'allowRepetition': value['allowRepetition'],
        'instruction': value['instruction'],
        'options': value['options'] == null ? undefined : ((value['options'] as Array<any>).map(CreateEnumerationEvaluationOptionDtoToJSON)),
        'trackItFilter': CreateEnumerationEvaluationParameterDtoTrackItFilterToJSON(value['trackItFilter']),
        '$type': value['$type'],
    });
}

